import React from "react";

import { makeStyles } from "@material-ui/core/styles";
import ListItem from "@material-ui/core/ListItem";
import ListItemSecondaryAction from "@material-ui/core/ListItemSecondaryAction";
import ListItemText from "@material-ui/core/ListItemText";

import IconButton from "@material-ui/core/IconButton";
import EditIcon from "@material-ui/icons/Edit";
import CheckCircleOutlineIcon from "@material-ui/icons/CheckCircleOutline";
import RemoveCircleOutlineIcon from "@material-ui/icons/RemoveCircleOutline";
import VpnKeyIcon from "@material-ui/icons/VpnKey";

import grey from "@material-ui/core/colors/grey";
import Typography from "@material-ui/core/Typography";
import { green, red } from "@material-ui/core/colors";
import Tooltip from "@material-ui/core/Tooltip";

const useStyles = makeStyles(theme => ({
  itemContent: {
    height: "auto",
    borderBottom: "solid",
    borderBottomColor: grey[200],
  },

  listItemText: {
    textTransform: "none",
  },

  contentTitle: {
    fontSize: "2.00rem",
    fontWeight: "bold",
    marginBottom: theme.spacing(4),
  },

  contentContainer: {
    width: "80%",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    flexWrap: "nowrap",
  },

  mainDetail: {
    "& div": {
      width: "100%",
      padding: "0.5rem 0 0 0",
      margin: "0.1rem 0",
      whiteSpace: "normal",

      "& label": {
        fontWeight: "bold",
        paddingRight: "0.5em",
      },
    },
  },

  trackingDetail: {
    "& div": {
      width: "100%",
      padding: "0.5rem 0 0 0",
      margin: "0.1rem 0",
      whiteSpace: "normal",

      "& label": {
        fontWeight: "bold",
        paddingRight: "0.5em",
      },
    },
  },

  active: {
    textTransform: "uppercase",
    color: green[500],
  },

  inactive: {
    textTransform: "uppercase",
    color: red[500],
  },

  actionContainer: {
    "& button": {
      margin: "10px 0",
    },
  },
}));

const SftpAccountListItem = ({
  account,
  selected,
  onEditClick,
  onPasswordClick,
  onDeactivateClick,
  onActivateClick,
}) => {
  const classes = useStyles();

  return (
    <ListItem
      selected={selected}
      classes={{ root: classes.itemContent }}
      key={account.sftpAccountId}
    >
      <ListItemText
        classes={{ root: classes.listItemText }}
        disableTypography={true}
        primary={
          <React.Fragment>
            <div className={classes.contentTitle}>{account.accountName}</div>
          </React.Fragment>
        }
        secondary={
          <React.Fragment>
            <div className={classes.contentContainer}>
              <div className={classes.mainDetail}>
                <div>
                  {account.active ? (
                    <Typography
                      component="span"
                      variant="h4"
                      classes={{ root: classes.active }}
                    >
                      Active
                    </Typography>
                  ) : (
                    <Typography
                      component="span"
                      variant="h4"
                      classes={{ root: classes.inactive }}
                    >
                      Inactive
                    </Typography>
                  )}
                </div>
                <div>
                  <label>Home Directory:</label>
                  {account.homeDirectory}
                </div>
              </div>
              <div className={classes.trackingDetail}>
                <div>
                  <div>
                    <label>Created By:</label>
                    {account.createdByUsername}
                  </div>
                  <div>
                    <label>Date Created:</label>
                    {account.dateCreated}
                  </div>
                </div>
                <div>
                  <div>
                    <label>Updated By:</label>
                    {account.updatedByUsername}
                  </div>
                  <div>
                    <label>Date Updated:</label>
                    {account.dateUpdated}
                  </div>
                </div>
              </div>
            </div>
          </React.Fragment>
        }
      />
      <ListItemSecondaryAction classes={{ root: classes.actionContainer }}>
        <Tooltip title="Edit Account">
          <IconButton
            autoFocus={selected}
            edge="end"
            aria-label="edit"
            onClick={() => onEditClick(account)}
          >
            <EditIcon fontSize="large" />
          </IconButton>
        </Tooltip>

        <Tooltip title="Change Password">
          <IconButton
            edge="end"
            aria-label="edit"
            onClick={() => onPasswordClick(account)}
          >
            <VpnKeyIcon fontSize="large" />
          </IconButton>
        </Tooltip>

        {account.active ? (
          <Tooltip title="Deactivate Account">
            <IconButton
              edge="end"
              aria-label="deactivate"
              onClick={() => onDeactivateClick(account)}
            >
              <RemoveCircleOutlineIcon fontSize="large" />
              <Typography variant="srOnly">Deactivate Account</Typography>
            </IconButton>
          </Tooltip>
        ) : (
          <Tooltip title="Activate Account">
            <IconButton
              edge="end"
              aria-label="activate"
              onClick={() => onActivateClick(account)}
            >
              <CheckCircleOutlineIcon fontSize="large" />
            </IconButton>
          </Tooltip>
        )}
      </ListItemSecondaryAction>
    </ListItem>
  );
};

export default SftpAccountListItem;
